import { useMemo } from "react"
import { useAppSelector } from "@/reducers/hooks"
import {
  getPlatesClaimedByChats,
  resolveDriverPlate,
} from "@/reducers/accountChatsSelectors"

/**
 * The vehicle plate to show beside a driver in the fuel report, or undefined.
 *
 * Deliberately reuses `resolveDriverPlate` rather than reading
 * `cars[carId].plates` directly: a driver's own card can name a car that
 * config has since assigned to someone else, and showing that stale snapshot
 * would put one truck under two drivers.
 */
export function useDriverPlate(
  driverJid: string,
  chatJid?: string,
): string | undefined {
  const profiles = useAppSelector((s) => s.profiles)
  const accountChats = useAppSelector((s) => s.accountChats)
  const cars = useAppSelector((s) => s.cars)

  return useMemo(() => {
    const safeCars = cars ?? {}
    const safeAccountChats = accountChats ?? {}
    return resolveDriverPlate({
      accountChat: chatJid ? safeAccountChats[chatJid] : undefined,
      cars: safeCars,
      driverProfile: (profiles ?? []).find((p) => p.jid === driverJid),
      platesClaimedByChats: getPlatesClaimedByChats(safeAccountChats, safeCars),
    })
  }, [driverJid, chatJid, profiles, accountChats, cars])
}
